window.FoxTheme = window.FoxTheme || {};
FoxTheme.config = {
    hasLocalStorage: false,
    mqlMobile: false,
    mqlTablet: false,
    mqlLaptop: false,
    mqlSmallDesktop: false,
    mediaQueryMobile: 'screen and (max-width: 767px)',
    mediaQueryTablet: 'screen and (max-width: 1023px)',
    mediaQueryLaptop: 'screen and (max-width: 1279px)',
    mediaQuerySmallDesktop: 'screen and (max-width: 1535px)',
    motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    isTouch: (() => {
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        const hasPointerFine = window.matchMedia('(pointer: fine)').matches;
        return hasTouch && !hasPointerFine;
    })(),
    isRTL: document.documentElement.getAttribute('dir') === 'rtl',
};

// Safe Custom Element Registration to prevent fatal DOM errors
const safeDefine = (name, constructor, options) => {
    if (!customElements.get(name)) {
        try {
            customElements.define(name, constructor, options);
        } catch (e) {
            console.warn(`FoxTheme: Suppressed duplicate registration for ${name}`);
        }
    }
};

console.log('%c' + window.FoxTheme.settings.themeName + ' theme (v' + window.FoxTheme.settings.themeVersion + ') by Foxecom - Speed Enhanced', 'font-size: 14px; color: #FF5C00;');

(function() {
    try {
        const key = 'hyper:test';
        window.localStorage.setItem(key, 'test');
        window.localStorage.removeItem(key);
        FoxTheme.config.hasLocalStorage = true;
    } catch (err) {}

    FoxTheme.DOMready = function(callback) {
        document.readyState != 'loading' ? callback() : document.addEventListener('DOMContentLoaded', callback);
    };

    FoxTheme.a11y = {
        trapFocusHandlers: {},
        getFocusableElements: (container) => {
            return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
        },
        trapFocus: (container, elementToFocus = container) => {
            var elements = FoxTheme.a11y.getFocusableElements(container);
            var first = elements[0];
            var last = elements[elements.length - 1];
            FoxTheme.a11y.removeTrapFocus();
            FoxTheme.a11y.trapFocusHandlers.focusin = (event) => {
                if (event.target !== container && event.target !== last && event.target !== first) return;
                document.addEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown, { passive: true });
            };
            FoxTheme.a11y.trapFocusHandlers.focusout = function() {
                document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
            };
            FoxTheme.a11y.trapFocusHandlers.keydown = function(event) {
                if (event.code.toUpperCase() !== 'TAB') return;
                if (event.target === last && !event.shiftKey) {
                    event.preventDefault();
                    first.focus();
                }
                if ((event.target === container || event.target === first) && event.shiftKey) {
                    event.preventDefault();
                    last.focus();
                }
            };
            document.addEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout, { passive: true });
            document.addEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin, { passive: true });
            elementToFocus.focus();
            if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
                elementToFocus.setSelectionRange(0, elementToFocus.value.length);
            }
        },
        removeTrapFocus: (elementToFocus = null) => {
            document.removeEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);
            document.removeEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
            document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
            if (elementToFocus) elementToFocus.focus();
        },
    };

    FoxTheme.utils = {
        throttle: (callback) => {
            let requestId = null, lastArgs;
            const later = (context) => () => {
                requestId = null;
                callback.apply(context, lastArgs);
            };
            const throttled = (...args) => {
                lastArgs = args;
                if (requestId === null) {
                    requestId = requestAnimationFrame(later(this));
                }
            };
            throttled.cancel = () => {
                cancelAnimationFrame(requestId);
                requestId = null;
            };
            return throttled;
        },
        setScrollbarWidth: () => {
            const scrollbarWidth = window.innerWidth - document.body.clientWidth;
            scrollbarWidth > 0 && document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
        },
        waitForEvent: (element, eventName) => {
            return new Promise((resolve) => {
                const eventHandler = (event) => {
                    if (event.target === element) {
                        element.removeEventListener(eventName, eventHandler);
                        resolve(event);
                    }
                };
                element.addEventListener(eventName, eventHandler, { passive: true });
            });
        },
        queryDomNodes: (selectors = {}, context = document) => {
            const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
                const findOne = typeof selector === 'string';
                const queryMethod = findOne ? 'querySelector' : 'querySelectorAll';
                const sl = findOne ? selector : selector[0];
                acc[name] = context && context[queryMethod](sl);
                if (!findOne && acc[name]) {
                    acc[name] = [...acc[name]];
                }
                return acc;
            }, {});
            return domNodes;
        },
        addEventDelegate: ({ context = document.documentElement, event = 'click', selector, handler, capture = false }) => {
            const listener = function(e) {
                for (let target = e.target; target && target !== this; target = target.parentNode) {
                    if (target.matches(selector)) {
                        handler.call(target, e, target);
                        break;
                    }
                }
            };
            context.addEventListener(event, listener, capture);
            return () => {
                context.removeEventListener(event, listener, capture);
            };
        },
        getSectionId: (element) => {
            if (element.hasAttribute('data-section-id')) {
                return element.dataset.sectionId;
            } else {
                if (!element.classList.contains('shopify-section')) {
                    element = element.closest('.shopify-section');
                }
                return element.id.replace('shopify-section-', '');
            }
        },
        debounce: (fn, wait) => {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        },
        fetchConfig: (type = 'json', method = 'POST') => {
            return {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: `application/${type}`
                },
            };
        },
        setStorage(key, value, expiryInDays = null) {
            if (!FoxTheme.config.hasLocalStorage) return;
            const item = { value: value };
            if (expiryInDays !== null) {
                const now = new Date();
                item.expiry = now.getTime() + expiryInDays * 86400000;
            }
            window.localStorage.setItem(key, JSON.stringify(item));
        },
        getStorage(key) {
            if (!FoxTheme.config.hasLocalStorage) return null;
            const itemStr = window.localStorage.getItem(key);
            if (!itemStr) return null;
            const item = JSON.parse(itemStr);
            if (item.expiry && new Date().getTime() > item.expiry) {
                window.localStorage.removeItem(key);
                return null;
            }
            return item.value;
        },
        postLink: (path, options) => {
            options = options || {};
            const method = options['method'] || 'post';
            const params = options['parameters'] || {};
            const form = document.createElement('form');
            form.setAttribute('method', method);
            form.setAttribute('action', path);
            for (const key in params) {
                for (const index in params[key]) {
                    for (const key2 in params[key][index]) {
                        const hiddenField = document.createElement('input');
                        hiddenField.setAttribute('type', 'hidden');
                        hiddenField.setAttribute('name', `${key}[${index}][${key2}]`);
                        hiddenField.setAttribute('value', params[key][index][key2]);
                        form.appendChild(hiddenField);
                    }
                }
            }
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },
        imageReady: (imageOrArray) => {
            if (!imageOrArray) return Promise.resolve();
            imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
            return Promise.all(imageOrArray.map((image) => {
                return new Promise((resolve) => {
                    if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
                        resolve();
                    } else {
                        image.onload = () => resolve();
                        image.onerror = () => resolve(); // Prevent blocking on broken images
                    }
                });
            }));
        },
        displayedMedia: (media) => {
            return Array.from(media).find((item) => {
                const style = window.getComputedStyle(item);
                return style.display !== 'none';
            });
        },
    };

    FoxTheme.pubsub = {
        PUB_SUB_EVENTS: {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            quantityRules: 'quantity-rules',
            quantityBoundries: 'quantity-boundries',
            variantChange: 'variant-change',
            cartError: 'cart-error',
            facetUpdate: 'facet-update',
            optionValueSelectionChange: 'option-value-selection-change',
        },
        subscribers: {},
        subscribe: (eventName, callback) => {
            if (FoxTheme.pubsub.subscribers[eventName] === undefined) {
                FoxTheme.pubsub.subscribers[eventName] = [];
            }
            FoxTheme.pubsub.subscribers[eventName] = [...FoxTheme.pubsub.subscribers[eventName], callback];
            return function unsubscribe() {
                FoxTheme.pubsub.subscribers[eventName] = FoxTheme.pubsub.subscribers[eventName].filter((cb) => {
                    return cb !== callback;
                });
            };
        },
        publish: (eventName, data) => {
            if (FoxTheme.pubsub.subscribers[eventName]) {
                FoxTheme.pubsub.subscribers[eventName].forEach((callback) => {
                    callback(data);
                });
            }
        },
    };

    FoxTheme.focusVisiblePolyfill = function() {
        const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
        let currentFocusedElement = null;
        let mouseClick = null;
        window.addEventListener('keydown', (event) => {
            if (navKeys.includes(event.code.toUpperCase())) {
                mouseClick = false;
            }
        }, { passive: true });
        window.addEventListener('mousedown', (event) => {
            mouseClick = true;
        }, { passive: true });
        window.addEventListener('focus', () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
            if (mouseClick) return;
            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add('focused');
        }, true);
    };

    FoxTheme.Carousel = (function() {
        class Carousel {
            constructor(container, options, modules = null) {
                this.container = container;
                let defaultModules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.A11y];
                if (modules) {
                    defaultModules = defaultModules.concat(modules);
                }
                this.options = { modules: defaultModules, ...options };
            }
            init() {
                this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
            }
        }
        return Carousel;
    })();

    FoxTheme.delayUntilInteraction = (function() {
        class ScriptLoader {
            constructor(callback, delay = 5000) {
                this.loadScriptTimer = setTimeout(callback, delay);
                this.userInteractionEvents = ['mouseover', 'mousemove', 'keydown', 'touchstart', 'touchend', 'touchmove', 'wheel'];
                this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
                this.userInteractionEvents.forEach((event) => {
                    window.addEventListener(event, this.onScriptLoader, { passive: true });
                });
            }
            triggerScriptLoader(callback) {
                callback();
                clearTimeout(this.loadScriptTimer);
                this.userInteractionEvents.forEach((event) => {
                    window.removeEventListener(event, this.onScriptLoader, { passive: true });
                });
            }
        }
        return ScriptLoader;
    })();

    FoxTheme.Currency = (function() {
        const moneyFormat = '${{amount}}';
        function formatMoney(cents, format) {
            if (typeof cents === 'string') cents = cents.replace('.', '');
            let value = '';
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const formatString = format || moneyFormat;
            function formatWithDelimiters(number, precision, thousands, decimal) {
                thousands = thousands || ',';
                decimal = decimal || '.';
                if (isNaN(number) || number === null) return 0;
                number = (number / 100.0).toFixed(precision);
                const parts = number.split('.');
                const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                const centsAmount = parts[1] ? decimal + parts[1] : '';
                return dollarsAmount + centsAmount;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount': value = formatWithDelimiters(cents, 2); break;
                case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
                case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
                case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
                case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
                case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'"); break;
            }
            return formatString.replace(placeholderRegex, value);
        }
        function getBaseUnit(variant) {
            if (!variant || !variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) return;
            return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
        }
        return { formatMoney: formatMoney, getBaseUnit: getBaseUnit };
    })();

    new FoxTheme.delayUntilInteraction(() => {
        document.body.removeAttribute('data-initializing');
    });

    FoxTheme.DOMready(FoxTheme.utils.setScrollbarWidth);

    const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
    FoxTheme.config.mqlMobile = mql.matches;
    mql.onchange = (event) => {
        FoxTheme.config.mqlMobile = event.matches;
        document.dispatchEvent(new CustomEvent(event.matches ? 'matchMobile' : 'unmatchMobile'));
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;
    mqlTablet.onchange = (event) => {
        FoxTheme.config.mqlTablet = event.matches;
        document.dispatchEvent(new CustomEvent(event.matches ? 'matchTablet' : 'unmatchTablet'));
    };

    const mqlLaptop = window.matchMedia(FoxTheme.config.mediaQueryLaptop);
    FoxTheme.config.mqlLaptop = mqlLaptop.matches;
    mqlLaptop.onchange = (event) => {
        FoxTheme.config.mqlLaptop = event.matches;
        document.dispatchEvent(new CustomEvent(event.matches ? 'matchLaptop' : 'unmatchLaptop'));
    };

    const mqlSmallDesktop = window.matchMedia(FoxTheme.config.mediaQuerySmallDesktop);
    FoxTheme.config.mqlSmallDesktop = mqlSmallDesktop.matches;
    mqlSmallDesktop.onchange = (event) => {
        FoxTheme.config.mqlSmallDesktop = event.matches;
        document.dispatchEvent(new CustomEvent(event.matches ? 'matchSmallDesktop' : 'unmatchSmallDesktop'));
    };

})();

try {
    document.querySelector(':focus-visible');
} catch (e) {
    FoxTheme.focusVisiblePolyfill();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

class HTMLUpdateUtility {
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        if (!oldNode || !newContent) return;
        preProcessCallbacks?.forEach((callback) => callback(newContent));
        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;
        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });
        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';
        postProcessCallbacks?.forEach((callback) => callback(newNode));
        setTimeout(() => oldNode.remove(), 500);
    }
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
}

class PageTransition extends HTMLElement {
    constructor() {
        super();
        window.addEventListener('beforeunload', () => { document.body.classList.add('page-loading'); });
        window.addEventListener('DOMContentLoaded', () => {
            FoxTheme.Motion.animate(this, { visibility: 'hidden', opacity: 0 }, { duration: 1 });
            document.body.classList.add('page-loaded');
            document.dispatchEvent(new CustomEvent('page:loaded'));
        });
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) document.body.classList.remove('page-loading');
        });
    }
}
safeDefine('page-transition', PageTransition);

const clearModalComponentCount = new WeakMap();
class ModalComponent extends HTMLElement {
    constructor() {
        super();
        this.events = { handleAfterHide: 'modal:handleAfterHide', handleAfterShow: 'modal:handleAfterShow' };
        this.classes = { show: 'modal-show', showing: 'modal-showing' };
    }
    static get observedAttributes() { return ['id', 'open']; }
    get isLockingNeeded() { return false; }
    get requiresBodyAppended() { return false; }
    get controls() { return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`)); }
    get designMode() { return this.hasAttribute('shopify-design-mode'); }
    get open() { return this.hasAttribute('open'); }
    get overlay() { return (this._overlay = this._overlay || this.querySelector('.fixed-overlay')); }
    get focusElement() {
        const button = this.querySelector('button');
        if (button) return button;
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        return focusableElements[0] || this;
    }
    connectedCallback() {
        this.abortController = new AbortController();
        this.controls.forEach((button) => {
            button.addEventListener('click', this.onButtonClick.bind(this), { signal: this.abortController.signal });
        });
        document.addEventListener('keyup', (event) => event.code === 'Escape' && this.hide(), { signal: this.abortController.signal, passive: true });
        if (this.designMode && Shopify.designMode) {
            const section = this.closest('.shopify-section');
            section.addEventListener('shopify:section:select', (event) => this.show(null, !event.detail.load), { signal: this.abortController.signal });
            section.addEventListener('shopify:section:deselect', this.hide.bind(this), { signal: this.abortController.signal });
        }
    }
    disconnectedCallback() {
        this.abortController?.abort();
        Shopify.designMode && document.body.classList.remove(this.classes.show);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'open':
                this.controls.forEach((button) => button.setAttribute('aria-expanded', newValue === null ? 'false' : 'true'));
                if (oldValue === null && (newValue === '' || newValue === 'immediate')) {
                    this.hidden = false;
                    this.removeAttribute('inert');
                    this.parentElementBeforeAppend = null;
                    if (this.requiresBodyAppended && this.parentElement !== document.body) {
                        this.parentElementBeforeAppend = this.parentElement;
                        document.body.append(this);
                    }
                    const handleShowTransitionPromise = this.handleShowTransition(newValue !== 'immediate') || Promise.resolve();
                    handleShowTransitionPromise.then(() => {
                        this.handleAfterShow();
                        this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, { bubbles: true }));
                    });
                } else if (oldValue !== null && newValue === null) {
                    this.setAttribute('inert', '');
                    const handleHideTransitionPromise = this.handleHideTransition() || Promise.resolve();
                    handleHideTransitionPromise.then(() => {
                        this.handleAfterHide();
                        if (!this.hasAttribute('inert')) return;
                        if (this.parentElement === document.body && this.parentElementBeforeAppend) {
                            this.parentElementBeforeAppend.appendChild(this);
                            this.parentElementBeforeAppend = null;
                        }
                        this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, { bubbles: true }));
                        this.hidden = true;
                    });
                }
                this.dispatchEvent(new CustomEvent('toggle', { bubbles: true }));
                break;
        }
    }
    onButtonClick(event) {
        event.preventDefault();
        this.open ? this.hide() : this.show(event.currentTarget);
    }
    hide() {
        if (!this.open) return;
        this.prepareToHide();
        this.removeAttribute('open');
        return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
    }
    show(activeElement = null, animate = true) {
        if (this.open) return;
        this.prepareToShow();
        this.activeElement = activeElement;
        this.setAttribute('open', animate ? '' : 'immediate');
        if (this.isLockingNeeded) {
            document.body.classList.add(this.classes.showing);
        }
        return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
    }
    handleAfterHide() {
        setTimeout(() => {
            FoxTheme.a11y.removeTrapFocus(this.activeElement);
            if (this.isLockingNeeded) {
                const currentModalCount = clearModalComponentCount.get(ModalComponent) - 1;
                clearModalComponentCount.set(ModalComponent, currentModalCount);
                document.body.classList.toggle(this.classes.show, currentModalCount > 0);
            }
        });
    }
    handleAfterShow() {
        FoxTheme.a11y.trapFocus(this, this.focusElement);
        if (this.isLockingNeeded) {
            const currentModalCount = clearModalComponentCount.get(ModalComponent) + 1;
            clearModalComponentCount.set(ModalComponent, currentModalCount);
            document.body.classList.remove(this.classes.showing);
            document.body.classList.add(this.classes.show);
        }
    }
    prepareToShow() {}
    prepareToHide() {}
    handleShowTransition() {
        setTimeout(() => { this.setAttribute('active', ''); }, 100);
        return new Promise((resolve) => {
            this.overlay.addEventListener('transitionend', () => { resolve(); }, { once: true });
        });
    }
    handleHideTransition() {
        this.removeAttribute('active');
        return new Promise((resolve) => {
            this.overlay.addEventListener('transitionend', () => { resolve(); }, { once: true });
        });
    }
}
safeDefine('modal-component', ModalComponent);
clearModalComponentCount.set(ModalComponent, 0);

class BasicModal extends ModalComponent {
    constructor() { super(); }
    get isLockingNeeded() { return true; }
    get requiresBodyAppended() { return true; }
}
safeDefine('basic-modal', BasicModal);

class DrawerComponent extends ModalComponent {
    constructor() {
        super();
        this.events = { handleAfterHide: 'drawer:handleAfterHide', handleAfterShow: 'drawer:handleAfterShow' };
    }
    get isLockingNeeded() { return true; }
    get requiresBodyAppended() { return true; }
}
safeDefine('drawer-component', DrawerComponent);

// Defer non-critical component initialization to allow main thread to clear faster
const deferComponentInitialization = () => {
    class SpotlightPick extends DrawerComponent {
        constructor() { super(); }
        get requiresBodyAppended() { return false; }
        get toggleButton() { return this.controls.find((control) => control.hasAttribute('data-toggle-spotlight')); }
        connectedCallback() {
            super.connectedCallback();
            if (this.toggleButton) { this.toggleTeaser(this.toggleButton, false, 0); }
        }
        onButtonClick(event) {
            event.preventDefault();
            const { target, currentTarget } = event;
            if (target.hasAttribute('data-close-teaser')) {
                this.toggleTeaser(this.toggleButton, true);
                return;
            }
            super.onButtonClick(event);
        }
        toggleTeaser(toggleEl, shouldHide, hideDurationHours = 4) {
            const currentTime = new Date().getTime();
            const hideDuration = hideDurationHours * 60 * 60 * 1000;
            if (shouldHide) {
                toggleEl.classList.add('hidden');
                localStorage.setItem('spotlight:teaserHidden', 'true');
                localStorage.setItem('spotlight:teaserHideTime', currentTime);
                localStorage.setItem('spotlight:teaserHideDuration', hideDuration);
            } else {
                const teaserHidden = localStorage.getItem('spotlight:teaserHidden');
                const teaserHideTime = localStorage.getItem('spotlight:teaserHideTime');
                const teaserHideDuration = localStorage.getItem('spotlight:teaserHideDuration');
                if (teaserHidden === 'true' && teaserHideTime) {
                    const timeElapsed = currentTime - parseInt(teaserHideTime);
                    if (timeElapsed < parseInt(teaserHideDuration)) {
                        toggleEl.classList.add('hidden');
                    } else {
                        localStorage.removeItem('spotlight:teaserHidden');
                        localStorage.removeItem('spotlight:teaserHideTime');
                        localStorage.removeItem('spotlight:teaserHideDuration');
                        toggleEl.classList.remove('hidden');
                    }
                } else {
                    toggleEl.classList.remove('hidden');
                }
            }
        }
    }
    safeDefine('spotlight-pick', SpotlightPick);

    class AccordionDetails extends HTMLDetailsElement {
        constructor() { super(); this.initAccordion(); }
        initAccordion() {
            this.isOpen = this.hasAttribute('open');
            this.summaryElement = this.querySelector('summary');
            this.contentElement = this.querySelector('summary + *');
            this.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
            this.summaryElement.addEventListener('click', this.toggleAccordion.bind(this));
            if (Shopify.designMode) { this.designModeEventSetup(); }
        }
        static get observedAttributes() { return ['open']; }
        get open() { return this.isOpen; }
        set open(value) {
            if (value !== this.isOpen) {
                this.isOpen = value;
                if (this.isConnected) {
                    this.animateAccordion(value);
                } else {
                    value ? this.setAttribute('open', '') : this.removeAttribute('open');
                }
                this.setAttribute('aria-expanded', value ? 'true' : 'false');
                this.setAttribute('aria-controls', this.contentElement.id);
                this.handleAfterToggle();
            }
        }
        handleAfterToggle() {}
        toggleAccordion(event) {
            event.preventDefault();
            this.open = !this.open;
        }
        close() { this.isOpen = false; this.animateAccordion(false); }
        async animateAccordion(isOpen) {
            this.style.overflow = 'hidden';
            if (isOpen) {
                this.setAttribute('open', '');
                this.parentElement.classList.add('active');
                await FoxTheme.Motion.timeline([
                    [this, { height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`] }, { duration: 0.25, easing: 'ease' }],
                    [this.contentElement, { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] }, { duration: 0.15, at: '<' }]
                ]).finished;
            } else {
                await FoxTheme.Motion.timeline([
                    [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
                    [this, { height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`] }, { duration: 0.25, at: '<', easing: 'ease' }]
                ]).finished;
                this.removeAttribute('open');
                this.parentElement.classList.remove('active');
            }
            this.style.height = 'auto';
            this.style.overflow = 'visible';
        }
        designModeEventSetup() {
            this.addEventListener('shopify:block:select', () => { this.open = true; });
            this.addEventListener('shopify:block:deselect', () => { this.open = false; });
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'open') { this.setAttribute('aria-controls', this.contentElement.id); }
        }
    }
    safeDefine('accordion-details', AccordionDetails, { extends: 'details' });

    class AccordionGroup extends AccordionDetails {
        constructor() { super(); }
        handleAfterToggle() {
            if (this.isOpen) {
                const parent = this.closest('.accordion-parent') || document;
                const siblingsAccordions = parent.querySelectorAll('details[is="accordion-group"]');
                siblingsAccordions.forEach((details) => {
                    if (details !== this) { details.open = false; }
                });
            }
        }
    }
    safeDefine('accordion-group', AccordionGroup, { extends: 'details' });

    // Include the remaining class definitions safely inside the deferred thread 
    // ensuring fast script execution without locking the browser UI parser
    const customClasses = [
        ['progress-bar', class extends HTMLElement {
            constructor() {
                super();
                if (this.hasAttribute('style')) return;
                if (this.dataset.from) { this.initProgress(); }
                FoxTheme.Motion.inView(this, this.init.bind(this));
            }
            init() { this.setPercentage(this.dataset.value, this.dataset.max); }
            initProgress() { this.setPercentage(this.dataset.from, this.dataset.max); }
            setPercentage(val1, val2) { this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`); }
        }],
        ['cart-count', class extends HTMLElement {
            constructor() { super(); this.cartUpdateUnsubscriber = undefined; }
            connectedCallback() { this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this)); }
            disconnectedCallback() { if (this.cartUpdateUnsubscriber) { this.cartUpdateUnsubscriber(); } }
            get itemCount() { return parseInt(this.innerText); }
            get type() { return this.dataset.type; }
            onCartUpdate(event) {
                if (event.cart.errors) return;
                let count = event.cart.item_count > 99 ? '99+' : event.cart.item_count;
                if (this.type === 'blank') { count = `(${count})`; }
                if (this.classList.contains('cart-count--absolute')) {
                    if (event.cart.item_count > 99) {
                        this.innerHTML = `<span class="text-sm-extra">${count}</span>`;
                        this.classList.add('cart-count--small-medium');
                    } else {
                        this.innerText = count;
                        this.classList.remove('cart-count--small-medium');
                    }
                } else {
                    this.innerText = count;
                }
                this.hidden = this.itemCount === 0 || event.cart.item_count === 0;
                const method = this.itemCount === 0 ? 'remove' : 'add';
                document.documentElement.classList[method]('cart-has-items');
            }
        }],
        ['video-element', class extends HTMLElement {
            constructor() {
                super();
                if (this.posterElement) { this.posterElement.addEventListener('click', this.handlePosterClick.bind(this)); }
                if (this.autoplay) { FoxTheme.Motion.inView(this, () => { if (!this.paused) { this.play(); } return () => { this.pause(); }; }); }
            }
            get posterElement() { return this.querySelector('[id^="DeferredPoster-"]'); }
            get autoplay() { return this.hasAttribute('autoplay'); }
            get playing() { return this.hasAttribute('playing'); }
            get player() {
                if (this.playerProxy) return this.playerProxy;
                const playerInit = this.initializePlayer();
                const playerPromise = playerInit instanceof Promise ? playerInit : Promise.resolve(playerInit);
                const placeholder = {};
                this.playerProxy = new Proxy(placeholder, {
                    get: (target, prop) => {
                        return async () => {
                            const resolvedPlayer = await playerPromise;
                            if (!resolvedPlayer) return;
                            this.handlePlayerAction(resolvedPlayer, prop);
                        };
                    },
                });
                return this.playerProxy;
            }
            static get observedAttributes() { return ['playing']; }
            handlePosterClick(event) {
                event.preventDefault();
                event.stopPropagation();
                if (this.playing) { this.paused = true; this.pause(); } else { this.paused = false; this.play(); }
            }
            play() { if (!this.playing) { const playerResult = this.player; if (playerResult) { playerResult.play(); } } }
            pause() { if (this.playing) { const playerResult = this.player; if (playerResult) { playerResult.pause(); } } }
            attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'playing') {
                    if (oldValue === null && newValue === '') { return this.dispatchEvent(new CustomEvent('video:play', { bubbles: true })); }
                    if (newValue === null) { return this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true })); }
                }
            }
            initializePlayer() {
                if (this.hasAttribute('source')) {
                    this.setAttribute('loaded', '');
                    this.closest('.media')?.classList.remove('loading');
                    return new Promise(async (resolve) => {
                        const templateElement = this.querySelector('template');
                        if (templateElement) { templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true)); }
                        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1023px)').matches;
                        const script = document.createElement('script');
                        script.type = 'text/javascript';
                        
                        if (this.getAttribute('source') === 'youtube') {
                            if (!window.YT || !window.YT.Player) {
                                script.src = 'https://www.youtube.com/iframe_api';
                                document.head.appendChild(script);
                                await new Promise((resolve2) => { script.onload = resolve2; });
                            }
                            await new Promise((res) => { if(window.YT && window.YT.Player) { res(); } else { window.onYouTubeIframeAPIReady = res; }});
                            const iframe = this.querySelector('iframe');
                            if (!iframe) { resolve(null); return; }
                            const player = new YT.Player(iframe, {
                                events: {
                                    onReady: () => { if (muteVideo) { player.mute(); } resolve(player); },
                                    onStateChange: (event) => {
                                        if (event.data === YT.PlayerState.PLAYING) { this.setAttribute('playing', ''); }
                                        else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) { this.removeAttribute('playing'); }
                                    },
                                },
                            });
                        }
                    });
                } else {
                    const templateElement = this.querySelector('template');
                    if (!templateElement) return null;
                    this.appendChild(templateElement.content.firstElementChild.cloneNode(true));
                    this.setAttribute('loaded', '');
                    this.closest('.media')?.classList.remove('loading');
                    const player = this.querySelector('video');
                    if (!player) return null;
                    player.addEventListener('play', () => { this.setAttribute('playing', ''); this.removeAttribute('suspended'); });
                    player.addEventListener('pause', () => { if (!player.seeking && player.paused) { this.removeAttribute('playing'); } });
                    return player;
                }
            }
            handlePlayerAction(target, prop) {
                if (!target) return;
                if (this.getAttribute('source') === 'youtube') {
                    prop === 'play' ? target.playVideo() : target.pauseVideo();
                } else {
                    if (prop === 'play' && !this.hasAttribute('source')) {
                        target.play().catch((error) => {
                            if (error.name === 'NotAllowedError') {
                                this.setAttribute('suspended', '');
                                target.controls = true;
                                const replacementImageSrc = target.previousElementSibling?.currentSrc;
                                if (replacementImageSrc) { target.poster = replacementImageSrc; }
                            }
                        });
                    } else {
                        target[prop]();
                    }
                }
            }
        }],
        ['motion-element', class extends HTMLElement {
            constructor() {
                super();
                this._parentCheckTimer = null;
                this._abortController = null;
                this._cachedMediaElements = null;
                this._isObserving = false;
                this._parentEventHandler = null;
            }
            connectedCallback() {
                if (FoxTheme.config.motionReduced) return;
                const parentMotionElement = this.closest('motion-element:not(:scope)');
                if (parentMotionElement) {
                    this.waitForParent(parentMotionElement);
                } else {
                    this.preInitialize();
                    this.setupObserver();
                }
            }
            disconnectedCallback() { this.cleanup(); }
            cleanup() {
                if (this._parentCheckTimer) { clearTimeout(this._parentCheckTimer); this._parentCheckTimer = null; }
                if (this._parentEventHandler) {
                    const parent = this.closest('motion-element:not(:scope)');
                    if (parent) { parent.removeEventListener('motion-initialized', this._parentEventHandler); }
                    this._parentEventHandler = null;
                }
                if (this._isObserving) { FoxTheme.MotionObserver.unobserve(this); this._isObserving = false; }
                if (this._abortController) { this._abortController.abort(); this._abortController = null; }
                this._cachedMediaElements = null;
                this.removeAttribute('data-initialized');
            }
            waitForParent(parentMotionElement) {
                if (parentMotionElement.hasAttribute('data-initialized')) {
                    this.preInitialize();
                    this.setupObserver();
                } else {
                    this._parentEventHandler = () => { this.preInitialize(); this.setupObserver(); };
                    parentMotionElement.addEventListener('motion-initialized', this._parentEventHandler, { once: true });
                    this._parentCheckTimer = setTimeout(() => {
                        if (!this.hasAttribute('data-initialized')) { this.preInitialize(); this.setupObserver(); }
                    }, 5000);
                }
            }
            setupObserver() {
                this._isObserving = true;
                FoxTheme.MotionObserver.observe(this, async () => {
                    try {
                        // NO LAZY LOAD DELAY - Executing immediately without strictly awaiting massive media payloads
                        await this.initialize();
                    } catch (error) {
                        if (this.isConnected) { console.warn('Motion animation error:', error); }
                    }
                });
            }
            get isHold() { return this.hasAttribute('hold'); }
            get isInstant() { return this.hasAttribute('data-instantly'); }
            get mediaElements() {
                if (!this._cachedMediaElements) { this._cachedMediaElements = Array.from(this.querySelectorAll('img, iframe, svg')); }
                return this._cachedMediaElements;
            }
            get animationType() { return this.dataset.motion || 'fade-up'; }
            get animationDelay() { return parseInt(this.dataset.motionDelay || 0) / 1000; }
            preInitialize() {
                if (this.isHold) return;
                this._abortController = new AbortController();
                switch (this.animationType) {
                    case 'fade-in': this.style.visibility = 'hidden'; FoxTheme.Motion.animate(this, { opacity: 0.01 }, { duration: 0 }); break;
                    case 'fade-up': this.style.visibility = 'hidden'; FoxTheme.Motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 }); break;
                    case 'zoom-in': FoxTheme.Motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 }); break;
                    case 'zoom-in-lg': FoxTheme.Motion.animate(this, { transform: 'scale(0)' }, { duration: 0 }); break;
                    case 'zoom-out': FoxTheme.Motion.animate(this, { transform: 'scale(1.08)' }, { duration: 0 }); break;
                    case 'zoom-out-sm': FoxTheme.Motion.animate(this, { transform: 'scale(1.03)' }, { duration: 0 }); break;
                }
            }
            async initialize() {
                if (this.isHold || !this.isConnected) return;
                this.setAttribute('data-initialized', 'true');
                this.dispatchEvent(new CustomEvent('motion-initialized', { bubbles: false }));
                try {
                    switch (this.animationType) {
                        case 'fade-in': this.style.visibility = 'visible'; await FoxTheme.Motion.animate(this, { opacity: 1 }, { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished; break;
                        case 'fade-up': this.style.visibility = 'visible'; await FoxTheme.Motion.animate(this, { transform: 'translateY(0)', opacity: 1 }, { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished; break;
                        case 'zoom-in': await FoxTheme.Motion.animate(this, { transform: 'scale(1)' }, { duration: 1.3, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished; break;
                        case 'zoom-in-lg': await FoxTheme.Motion.animate(this, { transform: 'scale(1)' }, { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished; break;
                        case 'zoom-out': await FoxTheme.Motion.animate(this, { transform: 'scale(1)' }, { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished; break;
                        case 'zoom-out-sm': await FoxTheme.Motion.animate(this, { transform: 'scale(1)' }, { duration: 1, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }).finished; break;
                    }
                } catch (error) {
                    if (error.name !== 'AbortError' && this.isConnected) { console.warn('Motion animation error:', error); }
                }
            }
            async resetAnimation(duration) {
                if (!this.isConnected) return;
                try {
                    switch (this.animationType) {
                        case 'fade-in': await FoxTheme.Motion.animate(this, { opacity: 0 }, { duration: duration ? duration : 1.5, delay: this.animationDelay, easing: duration ? 'none' : [0, 0, 0.3, 1], }).finished; break;
                        case 'fade-up': await FoxTheme.Motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0 }, { duration: duration ? duration : 0.5, delay: this.animationDelay, easing: duration ? 'none' : [0, 0, 0.3, 1], }).finished; break;
                        case 'zoom-in': case 'zoom-in-lg': case 'zoom-out': case 'zoom-out-sm': await FoxTheme.Motion.animate(this, { transform: 'scale(0)' }, { duration: duration ? duration : 1.3, delay: this.animationDelay, easing: duration ? 'none' : [0, 0, 0.3, 1], }).finished; break;
                    }
                } catch (error) {}
            }
            refreshAnimation() {
                this.removeAttribute('hold');
                this.preInitialize();
                setTimeout(() => { if (this.isConnected) { this.initialize(); } }, 50);
            }
        }]
    ];

    customClasses.forEach(([name, cls]) => safeDefine(name, cls));

    safeDefine('product-form', class extends HTMLFormElement {
        constructor() {
            super();
            this.productIdInput = this.querySelector('[name=id]');
            if(this.productIdInput) this.productIdInput.disabled = false;
            this.addEventListener('submit', this.handleFormSubmit);
            if (!window.__hsProductFormBfcacheInit) {
                window.__hsProductFormBfcacheInit = true;
                window.addEventListener('pageshow', (event) => {
                    if (!event.persisted) return;
                    document.querySelectorAll('[is="product-form"]').forEach((form) => {
                        const submitButton = form.querySelector('[type="submit"]');
                        if (!submitButton) return;
                        submitButton.removeAttribute('aria-disabled');
                        submitButton.classList.remove('btn--loading');
                    });
                });
            }
        }
        get cartDrawerElement() { return document.querySelector('cart-drawer'); }
        get submitButtonElement() { return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]')); }
        get isHideErrors() { return this.dataset.hideErrors === 'true'; }
        
        handleFormSubmit = (event) => {
            if (FoxTheme.settings.cartType === 'page') return;
            event.preventDefault();
            if (this.submitButtonElement.getAttribute('aria-disabled') === 'true') return;
            this.lastSubmittedElement = event.submitter || event.currentTarget;
            this.displayFormErrors();
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
            const config = FoxTheme.utils.fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            this.formData = new FormData(this);
            this.formData.append('sections', sectionsToBundle);
            this.formData.append('sections_url', window.location.pathname);
            config.body = this.formData;
            this.submitButtonElement.setAttribute('aria-disabled', 'true');
            this.submitButtonElement.classList.add('btn--loading');
            this.handleFormSubmission(config);
        };
        displayFormErrors = (errorMessage = false) => {
            if (this.isHideErrors) return;
            this.formErrorMessage = this.formErrorMessage || this.querySelector('.product-form__error-message');
            if (!this.formErrorMessage) {
                if (errorMessage !== false) { alert(errorMessage); }
            } else {
                this.formErrorMessage.toggleAttribute('hidden', !errorMessage);
                if (errorMessage !== false) { this.formErrorMessage.innerText = errorMessage; }
            }
        };
        resetFormState() {
            this.hasError = false;
            this.submitButtonElement.removeAttribute('aria-disabled');
            this.displayFormErrors();
        }
        handleFormSubmission = (config) => {
            fetch(`${FoxTheme.routes.cart_add_url}`, config).then((response) => response.json()).then(async (parsedState) => {
                if (parsedState.status) {
                    this.handleCartError(parsedState);
                    const cartJsonSub = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })).json();
                    this.updateCartState(cartJsonSub);
                    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
                    return;
                }
                const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })).json();
                cartJson['sections'] = parsedState['sections'];
                this.updateCartState(cartJson);
                this.dispatchProductAddedEvent(parsedState);
                this.showCartDrawer();
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.submitButtonElement.classList.remove('btn--loading');
                this.submitButtonElement.removeAttribute('aria-disabled');
            });
        };
        handleCartError = (parsedState) => {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: this.formData.get('id'),
                errors: parsedState.errors || parsedState.description,
                message: parsedState.message,
            });
            this.displayFormErrors(parsedState.description);
            document.dispatchEvent(new CustomEvent('product-ajax:error', { detail: { errorMessage: parsedState.description } }));
            this.hasError = true;
        };
        updateCartState = (cartJson) => { FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson }); };
        dispatchProductAddedEvent = (parsedState) => { document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } })); };
        showCartDrawer = () => {
            const quickViewModal = this.closest('quick-view-modal');
            if (quickViewModal) {
                if (this.cartDrawerElement && !this.cartDrawerElement.open) {
                    document.body.addEventListener(quickViewModal.events.handleAfterHide, () => {
                        setTimeout(() => { this.cartDrawerElement.show(this.lastSubmittedElement); });
                    }, { once: true });
                }
                quickViewModal.hide(true);
            } else {
                this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
            }
        };
    }, { extends: 'form' });

    safeDefine('swipe-wrapper', class extends HTMLDivElement {
        constructor() {
            super();
            this.swipeEl = null;
            this.resizeObserver = null;
            this.scrollHandler = this.updateScrollClasses.bind(this);
            this.classes = { active: 'swipe--active', begin: 'swipe--begin', end: 'swipe--end' };
        }
        connectedCallback() {
            this.swipeEl = this.querySelector('.swipe__element');
            if (!this.swipeEl) return;
            this.init();
            // Utilizing passive true ensures touch scrolling remains hardware accelerated without locking the main thread
            this.swipeEl.addEventListener('scroll', this.scrollHandler, { passive: true });
            if (this.swipeEl.offsetParent !== null) { this.updateScrollClasses(); }
            this.resizeObserver = new ResizeObserver(() => {
                if (this.swipeEl.offsetParent !== null) { this.updateScrollClasses(); }
            });
            this.resizeObserver.observe(this.swipeEl);
        }
        disconnectCallback() {
            if (this.swipeEl) { this.swipeEl.removeEventListener('scroll', this.scrollHandler); }
            if (this.resizeObserver) { this.resizeObserver.disconnect(); }
        }
        init() {
            if (this.swipeEl.classList.contains('swipe-all')) { this.setActive(true); return; }
            const swipeMobile = this.swipeEl.classList.contains('swipe-mobile');
            if (swipeMobile) {
                const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
                const update = () => { this.setActive(mql.matches); };
                update();
                mql.addEventListener('change', update);
            }
        }
        setActive(isActive = true) { this.classList.toggle(this.classes.active, isActive); }
        updateScrollClasses() {
            const scrollLeft = this.swipeEl.scrollLeft;
            const clientWidth = this.swipeEl.clientWidth;
            const scrollWidth = this.swipeEl.scrollWidth;
            const atStart = scrollLeft <= 0;
            const atEnd = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;
            this.classList.toggle(this.classes.begin, atStart);
            this.classList.toggle(this.classes.end, atEnd);
        }
    }, { extends: 'div' });
};

// Execute deferrable logic via requestIdleCallback to safeguard Total Blocking Time and LCP
if ('requestIdleCallback' in window) {
    requestIdleCallback(deferComponentInitialization, { timeout: 1500 });
} else {
    setTimeout(deferComponentInitialization, 50);
}

class MotionObserverManager {
    constructor() {
        this.observer = null;
        this.elements = new WeakMap();
        this.initialize();
    }
    initialize() {
        if (FoxTheme.config.motionReduced) return;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const callback = this.elements.get(entry.target);
                    if (callback) {
                        callback();
                        this.unobserve(entry.target);
                    }
                }
            });
        // threshold defaulted to 0 before, which counts a single visible
        // pixel as "in view" - fine for a fade-in animation, but this same
        // observer also gates autoplay video-element instances, and a
        // carousel slide peeking 1px into the viewport was enough to start
        // downloading and playing its full video file. 0.25 requires a
        // quarter of the element to actually be on screen first.
        }, { rootMargin: '0px 0px -80px 0px', threshold: 0.25 });
    }
    observe(element, callback) {
        if (!this.observer) return;
        this.elements.set(element, callback);
        this.observer.observe(element);
    }
    unobserve(element) {
        if (!this.observer) return;
        this.observer.unobserve(element);
        this.elements.delete(element);
    }
    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
            this.elements = new WeakMap();
        }
    }
}
FoxTheme.MotionObserver = new MotionObserverManager();